import { Box, Center, Spinner, Text } from '@chakra-ui/react'
import { ContentRenderer } from '@/components/common/ContentRenderer'
import { useEmbedShare } from './useEmbedShare'

export function EmbedPage() {
  const { state, content, error, format, colorMode } = useEmbedShare()

  if (state === 'loading' || state === 'decrypting') {
    return (
      <Center h="100vh">
        <Spinner size="lg" color="brand.500" />
      </Center>
    )
  }

  if (state === 'error') {
    return (
      <Center h="100vh">
        <Text color="stone.500">{error}</Text>
      </Center>
    )
  }

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      overflow="auto"
      p={6}
    >
      <Box maxW="4xl" mx="auto" data-color-mode={colorMode}>
        <ContentRenderer source={content} format={format} />
      </Box>
    </Box>
  )
}
